<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Information du Départ</h2>
      </v-row>

      <v-row class="mb-3">
        <span style="font-weight: bold">Remarque</span>&nbsp;: ceci est un rapport formel et doit
        être rédigé&nbsp;<span style="font-weight: bold">individuellement!</span>
      </v-row>

      <v-row>
        <v-simple-table>
          <thead>
            <tr v-for="field in fields" :key="field">
              <td style="width: 220px">
                {{ field.name }}
              </td>
              <td>
                <v-text-field v-model="inputs[field.inputKey]" />
              </td>
            </tr>
          </thead>
        </v-simple-table>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'UOttawaIntroductoryInfoTaskFr',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        partner: null,
        demonstrator: null,
        date: null,
      },
      fields: [
        {name: "Titre de l'expérience: ", inputKey: 'title'},
        {name: "Nom d'auteur: ", inputKey: 'author'},
        {name: "Nom du partenaire de l'auteur qui fait la soumission: ", inputKey: 'partner'},
        {name: 'Nom du TA (démonstrateur): ', inputKey: 'demonstrator'},
        {name: "Date que l'expérience a été effectueéé: ", inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
